/***
 * @file:æç¤ºä¿¡æ¯æå¡
 * @author: linkun.he
 * @Date: 2019-09-20 09:12:17
 */
import { Injectable } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";

import { I18NService } from "@ithinkdt/shared/i18n";
import {
  DT_DEFAULT_NOTIFICATION,
  DtNotificationDataOptions,
  NzNotificationDataOptions
} from "./notification.interface";

@Injectable({
  providedIn: "root"
})
export class DtNotificationService {
  constructor(
    private notificationSrv: NzNotificationService,
    private i18NSrv: I18NService
  ) {}

  success(title: string, options?: DtNotificationDataOptions) {
    const nzOptions: NzNotificationDataOptions = this.mergeMessageOptions(
      options
    );

    this.notificationSrv.success(this.itr(title), "", nzOptions);
  }

  error(title: string, options?: DtNotificationDataOptions) {
    const nzOptions: NzNotificationDataOptions = this.mergeMessageOptions(
      options
    );

    this.notificationSrv.error(this.itr(title), "", nzOptions);
  }

  info(title: string, options?: DtNotificationDataOptions) {
    const nzOptions: NzNotificationDataOptions = this.mergeMessageOptions(
      options
    );

    this.notificationSrv.info(this.itr(title), "", nzOptions);
  }

  warning(title: string, options?: DtNotificationDataOptions) {
    const nzOptions: NzNotificationDataOptions = this.mergeMessageOptions(
      options
    );
    this.notificationSrv.warning(this.itr(title), "", nzOptions);
  }

  blank(title: string, options?: DtNotificationDataOptions) {
    const nzOptions: NzNotificationDataOptions = this.mergeMessageOptions(
      options
    );

    this.notificationSrv.blank(this.itr(title), "", nzOptions);
  }

  itr(title: string) {
    return this.i18NSrv.interpret(title);
  }

  protected mergeMessageOptions(
    options?: DtNotificationDataOptions
  ): NzNotificationDataOptions {
    const nzOptions = this.formateOptions(options);
    const defaultOptions: NzNotificationDataOptions = {
      nzDuration: DT_DEFAULT_NOTIFICATION.nzDuration
    };
    return { ...defaultOptions, ...nzOptions };
  }

  protected formateOptions(
    options: DtNotificationDataOptions
  ): NzNotificationDataOptions {
    if (!options) {
      return;
    }

    const { dtDuration, dtPlacement, dtStyle, dtClass } = options;
    const nzOptions: NzNotificationDataOptions = {};
    nzOptions.nzDuration = dtDuration;
    nzOptions.nzStyle = dtStyle;
    nzOptions.nzClass = dtClass;
    if (dtPlacement) {
      this.notificationSrv.config({
        nzPlacement: dtPlacement
      });
    }
    return nzOptions;
  }
}
